export default "__VITE_ASSET__CgNTqtbZ__"